module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_6005.6adfe04d.png";